import React, { useState } from 'react';
import PlaylistsRow from './PlaylistsRow';
import styles from './PlaylistsToggle.module.css';

const PlaylistsToggle = ({ children, tracks, extraControls }) => {
  const [showRow, setShowRow] = useState(false);

  return (
    <div className={styles.wrap}>
      <div className={styles.row}>
        <div className={styles.leading}>
          {children}
          <div className={styles.extra}>{extraControls}</div>
        </div>
        <div className={styles.trailing}>
          <button
            className={`btn-danger-custom btn-ripple ${styles.playlistsBtn}`}
            onClick={() => setShowRow((prev) => !prev)}
            aria-label="Playlists"
            title="Playlists"
          >
            <i className={`tim-icons icon-bullet-list-67 ${styles.playlistsIcon}`} />
            <span className={styles.playlistsLabel}>Playlists</span>
          </button>
        </div>
      </div>
      {showRow && <PlaylistsRow tracks={tracks} />}
    </div>
  );
};

export default PlaylistsToggle;
